module.exports = __webpack_public_path__ + "img/left-arrow-subscribe.bed67a4f.svg";